import { render, staticRenderFns } from "./3.5_1.vue?vue&type=template&id=491d0c66&scoped=true"
import script from "./3.5_1.vue?vue&type=script&lang=js"
export * from "./3.5_1.vue?vue&type=script&lang=js"
import style0 from "./3.5_1.vue?vue&type=style&index=0&id=491d0c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d0c66",
  null
  
)

export default component.exports